import { render, staticRenderFns } from "./rec_pub_recs_req.vue?vue&type=template&id=65fbbb3b&scoped=true&"
import script from "./rec_pub_recs_req.vue?vue&type=script&lang=js&"
export * from "./rec_pub_recs_req.vue?vue&type=script&lang=js&"
import style0 from "./rec_pub_recs_req.vue?vue&type=style&index=0&id=65fbbb3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fbbb3b",
  null
  
)

export default component.exports